import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { RealTimeEvents } from '@app/core/signalr.events';
import { SignalrService } from '@app/core/signalr.service';
import { Subscription } from 'rxjs';
import { TelephonyProvider } from '../providers/telephony/telephony.provider';
import { TelephonyStateService } from '../providers/telephony/telephony.state.service';
import { AuthenticationService } from '@app/core';
@Injectable({
  providedIn: 'root',
})
export class DialpadService implements OnInit, OnDestroy {
  private compact = false;
  private draggable = false;

  subscriptions = new Array<Subscription>();
  constructor(
    private telephonyState: TelephonyStateService,
    public telephony: TelephonyProvider,
    private signalRService: SignalrService,
    private authService: AuthenticationService
  ) {
    this.subscriptions.push(
      this.telephony.voice.events.subscribe((event) => {
        switch (event.type) {
          case 'Call':
            switch (event.name) {
              case 'init':
                this.callEnabled = false;
                break;
              case 'accept':
                this.number = '';
                this.keypadOpen = false;
                this.callEnabled = false;
                this.endCallEnabled = true;
                this.muteUnmuteEnabled = true;
                this.holdResumeEnabled = true;
                break;
              case 'disconnect':
                this.isCustom = true;
                this.consultEnabled = false;
                this.conferenceEnabled = false;
                this.transferEnabled = false;
                this.holdResumeEnabled = false;
                this.muteUnmuteEnabled = false;
                this.toggleEnabled = false;
                this.cancelEnabled = false;
                this.keypadOpen = false;
                break;
              case 'dispose':
                this.isCustom = true;
                this.number = '';
                this.keypadOpen = true;
                this.callEnabled = false;
                this.consultEnabled = false;
                this.conferenceEnabled = false;
                this.transferEnabled = false;
                this.holdResumeEnabled = false;
                this.muteUnmuteEnabled = false;
                this.toggleEnabled = false;
                this.cancelEnabled = false;
                this.endCallEnabled = false;
                this.tcpaEnable = false;
                this.tcpaNumber = '';
                break;
              case 'wrong-dialing':
                this.number = '';
                this.setButtonVisibility();
                break;
              case 'customer_left':
                this.transferEnabled = false;
                this.conferenceEnabled = false;
                this.toggleEnabled = false;
                break;
            }
            break;
          case 'Consult':
            switch (event.name) {
              case 'init':
                this.consultEnabled = false;
                break;
              case 'failed':
                this.consultEnabled = true;
                this.setNumber('');
                this.setButtonVisibility();
                break;
              case 'completed':
                this.consultEnabled = false;
                this.holdResumeEnabled = false;
                this.toggleEnabled = true;
                this.cancelEnabled = true;
                break;
            }
            break;
          case 'Conference':
            switch (event.name) {
              case 'init':
                this.conferenceEnabled = false;
                break;
              case 'failed':
                this.conferenceEnabled = true;
                this.setNumber('');
                this.setButtonVisibility();
                break;
              case 'completed':
                this.consultEnabled = false;
                this.conferenceEnabled = false;
                this.holdResumeEnabled = false;
                this.toggleEnabled = true;
                this.cancelEnabled = true;
                break;
            }
            break;
          case 'Toggle':
            switch (event.name) {
              case 'init':
                this.toggleEnabled = false;
                break;
              case 'failed':
                this.toggleEnabled = true;
                break;
              case 'completed':
                this.toggleEnabled = !this.toggleEnabled;
                this.conferenceEnabled = true;
                const provider = this.authService.getTelephonyProvider();
                if (provider == 'ibex') {
                  setTimeout(() => {
                    this.toggleEnabled = true;
                  }, 1000);
                }
                break;
            }
            break;
          case 'Transfer':
            switch (event.name) {
              case 'init':
                this.transferEnabled = false;
                break;
              case 'failed':
                this.transferEnabled = true;
                this.setNumber('');
                this.setButtonVisibility();
                break;
              case 'completed':
                this.consultEnabled = false;
                this.conferenceEnabled = false;
                this.transferEnabled = false;
                this.toggleEnabled = false;
                this.holdResumeEnabled = false;
                this.cancelEnabled = false;
                this.endCallEnabled = true;
                this.muteUnmuteEnabled = false;
                this.number = '';
                this.holdResumeEnabled = false;
                break;
            }
            break;
          case 'Cancel':
            switch (event.name) {
              case 'init':
                this.cancelEnabled = false;
                break;
              case 'failed':
                this.cancelEnabled = true;
                break;
              case 'completed':
                this.consultEnabled = false;
                this.conferenceEnabled = false;
                this.transferEnabled = false;
                this.holdResumeEnabled = true;
                this.cancelEnabled = false;
                this.number = '';
                this.toggleEnabled = false;
                break;
              case 'third-party-bridge':
                this.consultEnabled = false;
                this.conferenceEnabled = false;
                this.transferEnabled = false;
                this.holdResumeEnabled = false;
                this.cancelEnabled = false;
                this.number = '';
                this.toggleEnabled = false;
                break;
            }
            break;
          case 'Hold':
            switch (event.name) {
              case 'init':
                this.holdResumeEnabled = false;
                break;
              case 'failed':
                this.holdResumeEnabled = true;
                break;
              case 'completed':
                this.holdResumeEnabled = true;
                break;
            }
            break;
        }
      })
    );
    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.ThirdPartyHangup).subscribe((thirdPartyHangup: any) => {
        console.log(new Date().toLocaleString() + '  ➤  thirdPartyHangup Signal R Events dialpad state ==> ', thirdPartyHangup);
        this.toggleEnabled = false;
        this.cancelEnabled = false;
        this.callEnabled = false;
        this.number = '';
        this.selectedNumber = '';
        this.isCustom = true;
        this.cancelEnabled = false;
      })
    );
  }
  ngOnInit(): void { }
  keypadOpen: boolean = true;
  disable: boolean = false;
  consultEnabled: boolean = false;
  conferenceEnabled: boolean = false;
  transferEnabled: boolean = false;
  holdResumeEnabled: boolean = false;
  muteUnmuteEnabled: boolean = false;
  toggleEnabled: boolean = false;
  cancelEnabled: boolean = false;
  endCallEnabled: boolean = false;
  callEnabled: boolean = false;
  number: string = '';
  selectedNumber: string = '';
  btnNumbers: Array<string> = [];
  isCustom: boolean = true;
  tcpaNumber: string = '';
  tcpaEnable: boolean = false;
  isVivintPitched: boolean = false;

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  public toggleCustom(): void {
    if (this.telephonyState.onConsultancy || this.telephonyState.onConference) {
      this.isCustom = !this.isCustom;
      return;
    }
    if (!this.isCustom) {
      this.consultEnabled = false;
      this.conferenceEnabled = false;
      this.transferEnabled = false;
      this.selectedNumber = '';
    } else if (this.isCustom) {
      this.consultEnabled = false;
      this.conferenceEnabled = false;
      this.transferEnabled = false;
      this.number = '';
    }
    this.isCustom = !this.isCustom;
  }
  public customNumberChange(value: any) {
    if (this.telephonyState.onConsultancy || this.telephonyState.onConference) {
      this.selectedNumber = value;
      return;
    }
    if (value) {
      this.consultEnabled = true;
      this.conferenceEnabled = true;
      this.transferEnabled = true;
    } else {
      this.consultEnabled = false;
      this.conferenceEnabled = false;
      this.transferEnabled = false;
    }
    this.selectedNumber = value;
  }

  public setNumber(text: string): void {
    this.number = text;
    this.setButtonVisibility();
  }
  public setDialScreenText(text: string): void {
    if (this.number.length != 10) {
      if (['*', '#'].indexOf(text) == -1) {
        this.number += text;
      }
      if (this.telephonyState.onCall && !this.telephonyState.isCallEnded) {
        this.telephony.voice.sendDTMF(null, text);
      }
    } else {
      if (this.telephonyState.onCall && !this.telephonyState.isCallEnded) {
        this.telephony.voice.sendDTMF(null, text);
      }
    }
    this.setButtonVisibility();
  }
  public removeDialScreenText() {
    this.number = this.number.replace(/.$/, '');
    this.setButtonVisibility();
  }
  public toggleTCPA() {
    this.tcpaEnable = !this.tcpaEnable;
  }
  public togglePitchedVivint() {
    this.isVivintPitched = !this.isVivintPitched;
  }
  public setTCPANumber(text: string): void {
    this.tcpaNumber = text;
  }
  public removeTCPANumber() {
    this.tcpaNumber = this.tcpaNumber.replace(/.$/, '');
    this.setButtonVisibility();
  }
  public validateNumber() {
    return this.number.length === 10;
  }
  public setButtonVisibility() {
    if (this.telephonyState.onConsultancy || this.telephonyState.onConference || this.telephonyState.onWrap) {
      return;
    }
    if (this.validateNumber()) {
      if (!this.telephonyState.onCall) {
        this.callEnabled = true;
      } else {
        if (this.telephonyState.onConsultancy) {
          this.toggleEnabled = true;
          this.cancelEnabled = true;
          this.consultEnabled = false;
          this.holdResumeEnabled = false;
        } else if (this.telephonyState.onConference) {
          this.toggleEnabled = true;
          this.cancelEnabled = true;
          this.consultEnabled = false;
          this.conferenceEnabled = false;
          this.holdResumeEnabled = false;
        } else {
          this.consultEnabled = true;
          this.conferenceEnabled = true;
          this.transferEnabled = true;
        }
        this.transferEnabled = true;
      }
    } else {
      this.callEnabled = false;
      if (this.telephonyState.onCall) {
        this.consultEnabled = false;
        this.conferenceEnabled = false;
        this.transferEnabled = false;
      }
    }
  }
  public sendDTMF() { }
  public toggleKeyPad() {
    this.keypadOpen = !this.keypadOpen;
  }

  public get isDraggable() {
    return this.draggable;
  }

  public set isDraggable(v: boolean) {
    this.draggable = v;
  }

  public get isCompact() {
    return this.compact;
  }

  public set isCompact(v: boolean) {
    this.compact = v;
  }
  public setKeypad(value: boolean) {
    this.keypadOpen = value;
  }
}
